$('.properties-product-carousel').slick({
    nextArrow: '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
    asNavFor: '.properties-data-carousel',
    dots: false,
    infinite: false,
    draggable: false,

    slidesToShow: 8,

    responsive: [{
        breakpoint: 1600,
        settings: {
            slidesToShow: 6
        }
    }, {
        breakpoint: 1200,
        settings: {
            slidesToShow: 5
        }
    }, {
        breakpoint: 992,
        settings: {
            slidesToShow: 4
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesToShow: 4
        }
    }, {
        breakpoint: 576,
        settings: {
            slidesToShow: 4
        }
    }]
});


$('.properties-data-carousel').slick({
    arrows: false,
    dots: false,
    infinite: false,
    draggable: false,
    swipe: false,
    touchMove: false,

    slidesToShow: 8,

    responsive: [{
        breakpoint: 1600,
        settings: {
            slidesToShow: 6
        }
    }, {
        breakpoint: 1200,
        settings: {
            slidesToShow: 5
        }
    }, {
        breakpoint: 992,
        settings: {
            slidesToShow: 4
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesToShow: 4
        }
    }, {
        breakpoint: 576,
        settings: {
            slidesToShow: 4
        }
    }]
});
